import { createStore, combineReducers, applyMiddleware } from 'redux';
import rootReducers from '../reducers';
import { AppState } from '../../types/store';
import { composeWithDevTools } from 'redux-devtools-extension';
import { create } from '@wix/fedops-logger';
import createSagaMiddleware from 'redux-saga';
import promiseMiddleware from 'redux-promised';
import createFedopsLogger from './middleware/fedopsLogger';
import rootSaga from '../sagas';
import logger from '../utils/logger';

export function configureStore(initialState: Partial<AppState>) {
  const sagaMiddleware = createSagaMiddleware({
    onError: error => {
      logger.error('Uncaught error in saga', error);
    },
  });
  const middleware = [sagaMiddleware, promiseMiddleware];

  if (typeof window !== undefined) {
    middleware.push(createFedopsLogger(create('da-user-profile')) as any);
  }

  const store = createStore<Partial<AppState>, any, {}, {}>(
    combineReducers(rootReducers),
    initialState,
    composeWithDevTools(applyMiddleware(...middleware))
  );
  const saga = sagaMiddleware.run(rootSaga);
  return { store, saga };
}
